<template>
  <div>
    <div class="leftMenu">
      <dl>
        <dt>
          <i class="icon-usercenter"></i>
          <span>用户中心</span>
        </dt>
        <dd>
          <router-link to="/usercenter" tag='span'>消息中心</router-link>
        </dd>
        <dd v-show="type==='BUYER'">
          <router-link to="/usercenter/myshop" tag='span'>我的求购</router-link>
        </dd>
        <dd v-show="type==='BUYER'">
          <router-link to="/usercenter/collectlist" tag='span'>我的收藏</router-link>
        </dd>
        <dd v-show="type==='BUYER'">
          <router-link to="/usercenter/myappointment" tag='span'>我的预约</router-link>
        </dd>
        <dd v-show="type==='SELLER'" >
          <router-link to="/usercenter/buyinginformation" tag='span'>求购信息</router-link>
        </dd>
        <!-- <dd>
          <router-link to="/" tag='span'>店铺信息维护</router-link>
        </dd> -->
        <dd>
          <router-link to="/usercenter/maintaincompany" tag='span'>企业信息维护</router-link>
        </dd>
        <dd>
          <router-link to="/usercenter/maintainuser" tag='span'>个人信息维护</router-link>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      name:'userMenu',
      data(){
        return {
          type:''
        }
      },
      mounted(){
        const use = this.$storage.get('__USD');
        if(use){
          this.type = use.institutionType;
        }
      }
    }
</script>
<style scoped lang="scss">
  .leftMenu{
    width: 220px;
    padding: 0 0 30px;
    background-color: #E7E7E7;
    dl{
      width: 220px;
      margin: 0 auto;
      text-align: left;
      dt{
        height: 50px;
        background-color: #719BF0;
        margin-bottom: 50px;
        line-height: 50px;
        padding-left: 45px;
        font-size: 17px;
        color: white;
        .icon-usercenter{
          display: inline-block;
          height: 19px;
          width: 19px;
          background-image: url("../../assets/images/centerUser.png");
          background-size: cover;
          background-repeat: no-repeat;
          /*vertical-align: middle;*/
          margin-left: -27px;
        }
      }
      dd{
        cursor: pointer;
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        margin: 0 0 5px 0;
        span{
          padding-left: 45px;
          display: block;
          &.router-link-exact-active{
            background-color: #444F66;
            color: #fff;
          }
        }
        &:hover{
          background-color: #444F66;
          color: white;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/userCenter/LeftMenu.vue